var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoText = function SvgLogoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "m26.788 11.073-1.4-2.52-7.401.965 2.69-5.057L19.203 1.8l-3.06.324-2.594 5.123L10.063.724l-2.956.324-1.047 2.19 3.826 7.334-8.854 1.194L.008 14l1.327 2.72 8.005-1.135-2.292 4.503 1.326 2.595 2.89-.472 2.374-4.46 3.722 7.158 3-.493 1.224-2.123-4.194-7.844 8.219-1.18 1.201-2.166-.014-.03h-.008z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__a)",
    d: "m16.395 12.533-2.971.48 5.108 9.759 3.045-.48-5.19-9.759h.008z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__b)",
    d: "m7.113 1.048-1.054 2.19 3.825 7.334 2.116-.31-4.887-9.214z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__c)",
    d: "M13.468 13.005 12 10.263l4.15-8.146 1.57 2.809-4.246 8.079h-.007z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__d)",
    d: "m12.332 15.23 1.135-2.226 5.064 9.768-1.164 2.13-5.035-9.664v-.007z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__e)",
    d: "m8.374 22.676-1.327-2.595 2.292-4.504 3-.36-3.965 7.452v.007z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9A9A",
    d: "M1.032 11.759 0 13.992l1.327 2.728 1.135-2.212-1.43-2.742v-.007z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__f)",
    d: "m1.334 16.712 1.135-2.211 11.006-1.497-1.128 2.212-11.013 1.496z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__g)",
    d: "m17.39 14.442-.989-1.91 10.409-1.437-1.202 2.167-8.226 1.18h.007z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__h)",
    d: "m11.264 22.197-2.89.472 3.966-7.453 1.305 2.521-2.381 4.46z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__i)",
    d: "m20.684 4.453-2.97.472-4.246 8.08 2.919-.48 4.297-8.072z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-text_svg__j)",
    d: "m17.367 24.902 1.165-2.13 3.052-.487-1.217 2.123-3 .494z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    fillRule: "evenodd",
    d: "M94.237 2.393h-.302V8.93c-.951-1.002-2.403-1.658-4.342-1.658-1.939 0-3.649.73-4.865 2.005-1.216 1.275-1.931 3.081-1.931 5.219 0 2.263.707 4.076 1.93 5.322 1.224 1.246 2.927 1.902 4.866 1.902 1.939 0 3.383-.789 4.342-1.799v1.645h2.779V2.385h-2.477v.008zm-8.61 12.096c0-1.408.435-2.58 1.157-3.398.723-.81 1.762-1.29 3.023-1.29 1.26 0 2.27.48 3 1.305s1.157 2.012 1.157 3.435-.427 2.543-1.157 3.347c-.722.803-1.755 1.282-3 1.282-1.246 0-2.293-.479-3.023-1.29-.73-.81-1.157-1.983-1.157-3.398v.007zm21.363-7.194c-2.05 0-3.804.73-5.05 2.012-1.246 1.276-1.96 3.089-1.96 5.212 0 2.123.714 3.929 1.96 5.211 1.246 1.283 3 2.013 5.05 2.013 2.049 0 3.803-.73 5.049-2.012 1.246-1.276 1.961-3.09 1.961-5.212 0-2.123-.715-3.93-1.961-5.212-1.246-1.282-3-2.012-5.049-2.012zm-4.18 7.224c0-1.386.428-2.558 1.157-3.376.73-.818 1.762-1.305 3.023-1.305 1.26 0 2.292.487 3.022 1.305.73.825 1.157 1.997 1.157 3.376 0 1.378-.427 2.558-1.157 3.376-.73.818-1.762 1.305-3.022 1.305-1.261 0-2.293-.487-3.023-1.305-.729-.826-1.157-1.998-1.157-3.376zm-32.78-5.72c.861-.84 2.137-1.504 3.943-1.504 1.489 0 2.882.42 3.907 1.445 1.024 1.024 1.636 2.61 1.636 4.85v7.991h-2.779v-7.858c0-1.312-.31-2.263-.84-2.89-.524-.619-1.29-.95-2.308-.95-1.098 0-1.982.42-2.594 1.142-.62.73-.98 1.776-.98 3.066v7.49h-2.78V7.457h2.779v1.349l.015-.007zM56.406 2.393h-.303v3.103h3.104V2.393h-2.802zM51.962 7.36h-.303v2.596h4.777v8.949H51.66V21.5h12.324v-2.595h-4.776V7.369h-7.246V7.36zM35.015 2.408h2.779V14.21l6.833-6.687.088-.088h3.649l-.523.516-5.64 5.514 5.913 7.614.376.48h-3.435l-.089-.118-4.703-6.096-2.455 2.41v3.811H35.03V2.415l-.014-.007z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__b",
    x1: 6.42,
    x2: 10.725,
    y1: 1.299,
    y2: 10.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__c",
    x1: 16.851,
    x2: 13.048,
    y1: 2.39,
    y2: 12.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C7C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__d",
    x1: 15.863,
    x2: 15.664,
    y1: 14.154,
    y2: 16.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5E60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84868A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__e",
    x1: 13.799,
    x2: 9.634,
    y1: 14.833,
    y2: 18.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__f",
    x1: 2.617,
    x2: 13.305,
    y1: 15.223,
    y2: 14.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__g",
    x1: 16.224,
    x2: 26.95,
    y1: 13.52,
    y2: 12.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__h",
    x1: 9.804,
    x2: 12.215,
    y1: 18.636,
    y2: 19.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-text_svg__j",
    x1: 18.178,
    x2: 21.444,
    y1: 23.804,
    y2: 23.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-text_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(78.87 1.063 13.974) scale(13.0186 10.3708)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D4D4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-text_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-82.98 17.432 -2.154) scale(9.0321 8.6653)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B3B4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616160"
  })))));
};
export default SvgLogoText;